var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.375 12.75h-12.75V9.562a5.312 5.312 0 0 0-5.313-5.312H28.688a5.312 5.312 0 0 0-5.313 5.313v3.187h-12.75a2.125 2.125 0 0 0 0 4.25h2.258l2.523 40.497c.189 3.566 2.922 6.253 6.375 6.253H46.22c3.47 0 6.149-2.627 6.375-6.242L55.117 17h2.258a2.125 2.125 0 0 0 0-4.25Zm-31.8 42.5H25.5a2.125 2.125 0 0 1-2.125-2.05l-1.063-29.75a2.126 2.126 0 1 1 4.25-.15l1.063 29.75a2.126 2.126 0 0 1-2.05 2.2Zm10.55-2.125a2.125 2.125 0 0 1-4.25 0v-29.75a2.125 2.125 0 0 1 4.25 0v29.75Zm4.25-40.375h-12.75V9.562A1.051 1.051 0 0 1 28.688 8.5h10.625a1.05 1.05 0 0 1 1.062 1.063v3.187Zm4.25 40.45a2.125 2.125 0 0 1-2.125 2.05h-.077a2.126 2.126 0 0 1-2.048-2.2l1.063-29.75a2.127 2.127 0 0 1 4.25.15L44.624 53.2Z",
    fill: "#F54562"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteView);
export default __webpack_public_path__ + "static/media/delete_view.39b1dad127c4e689ee0fa121a54febbb.svg";
export { ForwardRef as ReactComponent };